var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { StateConfigContext } from '../../providers';
import { getProgressProps } from './ProgressStyles';
import CircularProgress from './components/circular-progress/CircularProgress';
import LinearProgress from './components/linear-progress/LinearProgress';
import { getTestId } from '../../utils';
var componentTypes = {
  circular: CircularProgress,
  linear: LinearProgress
};
export var Progress = props => {
  var stateContext = useContext(StateConfigContext);
  var progressProps = getProgressProps(props, stateContext);
  var type = progressProps.type,
    _progressProps$testID = progressProps.testID,
    testID = _progressProps$testID === void 0 ? 'Progress' : _progressProps$testID,
    restProps = __rest(progressProps, ["type", "testID"]);
  var ProgressComponent = componentTypes[type];
  return _jsx(ProgressComponent, Object.assign({
    accessibilityValue: {
      text: (restProps === null || restProps === void 0 ? void 0 : restProps.value) + ''
    },
    accessibilityRole: "progressbar"
  }, getTestId(testID), restProps));
};